import { AutoWidthCenter } from '../../../../components/layout/AutoWidthCenter'
import { Box, Button, Divider, Heading, HStack, useColorModeValue } from '@chakra-ui/react'
import { FaqCategoryForm } from '../../../../components/secure/dashboard/faq/FaqCategoryForm'
import { history } from '../../../../ApplicationRouter'
import { useTranslation } from 'react-i18next'

export const CreateFaqCategory = () => {
  const { t } = useTranslation();

  return (
    <AutoWidthCenter bg={useColorModeValue("bgPrimaryWhite", "bgPrimaryBlack")}>
      <Box py="5">
        <HStack pb="5" justifyContent="space-between">
          <Heading as="h1">{t('Faq_Category.Create')}</Heading>
          <Button onClick={() => history.back()}>{t('Return')}</Button>
        </HStack>
        <Divider />
        <FaqCategoryForm />
      </Box>
    </AutoWidthCenter >
  )
}